<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4">
      <v-layout wrap
        ><v-flex xs12 sm6>
          <span class="main-title">MESSENGER SUMMARY | &nbsp;</span>
          <span class="submain-title">Sale messenger report</span></v-flex
        >
        <v-flex xs12 sm6 style="display:flex;justify-content:flex-end">
          <download-excel
            :data="export_messegner_format"
            :fields="{
              No: 'No',
              'Order code': 'order_code',
              'Rider name': 'rider',
              'Add on': 'add_on',
              Transport: 'transport',
              'Extra time': 'extra_time',
              Promotion: 'promotion',
              Revenue: 'revenue',
            }"
            :name="
              'SaleMessengerReport_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.xls'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>
          <download-excel
            type="csv"
            :data="export_messegner_format"
            :fields="{
              No: 'No',
              'Order code': 'order_code',
              'Rider name': 'rider',
              'Add on': 'add_on',
              Transport: 'transport',
              'Extra time': 'extra_time',
              Promotion: 'promotion',
              Revenue: 'revenue',
            }"
            :name="
              'SaleMessengerReport_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.csv'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel>
        </v-flex></v-layout
      >
    </div>
    <searchOrderStatus />
    <saleMessengerReportList />
  </div>
</template>

<script>
import searchOrderStatus from "@/components/back-office/Report/SearchBar/SearchOrderStatus";
import saleMessengerReportList from "@/components/back-office/Report/SaleMessengerReportList";
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  components: {
    saleMessengerReportList,
    searchOrderStatus,
  },
  destroyed() {
    this.$store.commit("fetchSaleMessengerReport/resetState");
  },
  computed: {
    ...mapState({
      export_messegner_format: (state) =>
        state.fetchSaleMessengerReport.export_messegner_format,
      search_config: (state) =>
        state.fetchSaleMessengerReport.clone_config_path,
    }),
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Sale messenger report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/sale_messenger_report",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
